export default __webpack_public_path__ + "8e63e9729f444cbf1cd57d5f2b974ad9.svg";